//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { BatchRepertoireAssignmentInputItem } from './BatchRepertoireAssignmentInputItem';
import { BatchRepertoireAssignmentUpdateItem } from './BatchRepertoireAssignmentUpdateItem';
import { BatchRepertoireAssignmentDeleteOptions } from './BatchRepertoireAssignmentDeleteOptions';

export class BatchRepertoireAssignmentUpdateItems extends ItemBase {
    InputItems: BatchRepertoireAssignmentInputItem[] = [];
    UpdateItems: BatchRepertoireAssignmentUpdateItem[] = [];
    DeleteItems: BatchRepertoireAssignmentDeleteOptions[] = [];

    constructor(initializer?: Partial<BatchRepertoireAssignmentUpdateItems>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BatchRepertoireAssignmentUpdateItems";
}
